<template>
  <div class="product-info-wrapper">
    <div class="main-width py-5">
		<VBreadcrumb :options="[{ label: '首页', to: '/' }, {label: '产品列表',to:productListLink},{label:'产品详情'}]"></VBreadcrumb>
    </div>

    <div class="main-width main-body">
      <div class="product-info">
        <div class="product-info-content">
          <!-- S 标题  -->
          <div class="product-name">
            <el-tooltip placement="bottom-start" popper-class="popper-class-tooltip" v-if="data.level_pic" :visible-arrow="false" effect="light">
              <div slot="content">
                <div class="mb-1"><span class="title">黑标：</span>精选邮轮市场畅销产品，一手库存、价格，快速成交，提供有竞争力的佣金，获得更高的回报。</div>
                <div class="mb-1"><span class="title">金标：</span>覆盖市场大部分需求，实时更新库存，让您时刻了解产品的可售性，保障业务稳定发展。</div>
                <div class="mb-1"><span class="title">银标：</span>覆盖全球市场多个领域，确保满足不同客户的需求，推动您的业务多元化的发展。</div>
              </div>
              <div class="label-icon">
                <el-image fit="cover" class="label-icon" :src="data.level_pic"></el-image>
              </div>
            </el-tooltip>
            <h2 class="product-title line-clamp-2" :class="{'info-name': data.level_pic}">{{ data.product_name }}</h2>
          </div>
          <Coupon style="padding-top: 10px;" :coupon_list="data.coupon_list"></Coupon>
          <div class="product-base-info">
            <span class="product-depart">{{ data.departure_city_label }}</span>
            <v-divider direction="vertical" />
            <span class="product-no">产品编号：{{ data.product_no }}</span>
            <div class="copy-no-btn">
              <i class="ficon ficon-fuzhi" title="复制" v-clipboard="() => data.product_no" v-clipboard:success="handleCopySuccess"
                v-clipboard:error="handleCopyError"></i>
            </div>
          </div>
          <div class="product-tag-group">
            <el-tag v-for="(tag, index) in data.tags" :key="index" class="siblings:ml-1" size="small" type="success">{{ tag }}</el-tag>
          </div>

          <!-- 直客 部分 -->
          <template v-if="isCustomer">
            <div class="distributor__price">
              <div class="distributor__sale">
                <span class="distributor__sale__label">售价:</span>
                <div class="text-2xl">
                  <span class="distributor__sale__rangin">
                    ￥{{ data.min_price }}
                  </span>
                  <span class="union">起/人</span>
                </div>
              </div>
            </div>
            <!-- S 销售人员 -->
            <!-- <div class="productsale__wrapper">
              <div class="productsale">
                <el-popover :append-to-body="false" placement="bottom-start" popper-class="productsale__popover__wrapper" trigger="click"
                  v-for="(sale, itemindex) in data.sales_info" :key="itemindex">
                  <div class="productsale__item" slot="reference">
                    <el-image class="productsale__item__icon" fit="cover" :src="sale.photo"></el-image>
                    <div class="productsale__item__info">
                      <p class="productsale__item__name">{{ sale.contacts_name }}</p>
                      <p class="productsale__item__company">{{ sale.company_name }}</p>
                    </div>
                    <div class="productsale__item__tag">
                      <i class="ficon ficon-fuzhi"></i>
                      联系TA
                    </div>
                  </div>
                  <div class="productsale__popover">
                    <p class="productsale__popover__name">{{ sale.contacts_name }}</p>
                    <p class="productsale__popover__phone">
                      <span>手机 {{ sale.contacts_mobile }}</span>
                      <span class="productsale__popover__copy" v-clipboard="sale.contacts_mobile" v-clipboard:success="handleCopySuccess"
                        v-clipboard:error="handleCopyError">复制</span>
                    </p>
                    <p class="productsale__popover__company">{{ sale.company_name }}</p>
                  </div>
                </el-popover>
              </div>
            </div> -->
          </template>
          <!-- 分销商 -->
          <template v-else>
            <div class="distributor">
              <div class="distributor__price">
                <div class="distributor__sale">
                  <span class="distributor__sale__label">售价:</span>
                  <div class="text-2xl">
                    <span class="distributor__sale__rangin">
                      ￥{{ data.min_price }}
                    </span>
                    <span class="union">起/人</span>
                  </div>
                </div>
                <Profit class="distributor__profit" :min_profit="data.min_profit" :max_profit="data.max_profit" />
              </div>
              <!-- 分享店铺产品 -->
              <div class="flex items-center">
                <el-button v-if="!isInShop && isOpenShop" type="primary" class="min-w-[140px] px-4 rounded-md" icon="ficon ficon-dianpuguanlishuju" @click="onJoinShop">
                  <span class="ml-3">加入店铺</span>
                </el-button>

                <nuxt-link to="/topic/shop-tool" target="_blank" class="el-button rounded-md min-w-[140px] px-4 el-button--primary is-plain !border-primary">
                  <span class="ml-[6px]">玩转店铺赚大钱</span>
                  <i class="ficon ficon-arrow-right"></i>
                </nuxt-link>
                <div class="ml-4">
                  <div class="product__title__action" v-if="data.status !== 0">
                    <el-tooltip placement="bottom-start" popper-class="p-5">
						<template #content>
							<p v-html="shareTooltipOptins.content" />
						</template>
                      <span @click="handleShareShopProduct" class="transition-colors hover:text-primary">
                        <i class="product__title__icon ficon ficon-fenxiang"></i>
                        分享
                      </span>
                    </el-tooltip>
                    <span class="product__title__split"></span>
                    <span @click="onToggleFavorite" class="transition-colors hover:text-primary" :class="{ 'product__title--active': isFavorite }">
                      <span class="product__title__icon">
                        <i class="ficon" :class="{
							'ficon-shoucangmoren': !isFavorite,
							'ficon-yishoucang': isFavorite
						}"></i>
                      </span>
                      {{ isFavorite ? "已收藏" : "收藏" }}
                    </span>
                  </div>
                </div>
				<el-button type="default" class="tour_btn" plain @click="onDownloadTourFile">
					<i class="ficon ficon-wenjianxiazai1 font_24"></i>
					<em>行程文件下载</em>
				</el-button>
              </div>


              <div class="distributor__tip" v-if="data.policy && data.policy.length">
                <i class="ficon ficon-tanhaoshixin"></i>
                <div class="distributor__tip__content">
                  <pre v-for="policy in data.policy" :key="policy">{{ policy }}</pre>
                </div>
              </div>
            </div>
          </template>

          <!-- 下架 -->
          <img v-if="data.status == 0" class="status-icon" src="../../assets/img/product/off-shelf-icon.png" alt="" />
        </div>
        <div class="product-info-cover">
          <el-carousel height="232px">
            <el-carousel-item v-for="(image, index) in data.images" :key="index">
              <el-image class="w-full h-full rounded-lg" fit="cover" :src="image" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!--分享店铺产品二维码-->
    <share-shop-product ref="shareShopProduct"></share-shop-product>
  </div>
</template>

<script>
import { useRoute, ref } from "@nuxtjs/composition-api";
import { DownloadByStreamingFile } from "@/utils/file-download";

import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";
import Profit from "@/components/Profit.vue";
import Coupon from "@/views/product/components/Coupon.vue";

import { Portal } from "@/libs/simple-portal";

// directives
import clipboard from "@/directives/clipboard";
import useProductFavorite from "./composables/useProductFavorite";
import useProductJoinShop from "./composables/useProductJoinShop";
import { computed, defineComponent, watch, useStore } from "@nuxtjs/composition-api";
import VBreadcrumb from '@/components/VBreadcrumb.vue'
import combineURLs from "~/utils/combineURLs";

export default defineComponent({
	name: "DetailInfo",
	components: {
		Portal,
		ShareShopProduct,
		Profit,
		Coupon,
		VBreadcrumb
	},
	directives: { clipboard },
	props: {
		data: {
			type: Object,
			default: () => ({
				id: "",
				product_no: "",
				tags: [],
				images: [],
				cruises_info: {
					cover: "",
					title: ""
				},
				departure: "",
				status: 1,
				in_shop: false,
				is_favorite: true
			})
		}
	},
	setup(props) {
		const store = useStore();
		const route = useRoute();
		const product_no = computed(() => props.data.product_no);
		const { isFavorite, favoriteIcon, onToggleFavorite } =
			useProductFavorite(product_no);
		const { isInShop, onJoinShop, updateJoinShopStatus } =
			useProductJoinShop(product_no);
		watch(
			() => [props.data.is_favorite, props.data.in_shop],
			() => {
				isFavorite.value = !!props.data.is_favorite;
				isInShop.value = !!props.data.in_shop;
			},
			{
				immediate: true
			}
		);
		const isOpenShop = computed(() => store.getters.isOpenShop)

		const onDownloadTourFile = ()=>{
			const { productNo } = route.value.params;
			let href = combineURLs(window.location.origin, `/auto/product/trip-pdf?product_no=${productNo}`);
			window.open(href, "_blank");
		}

		return {
			product_no,
			isFavorite,
			favoriteIcon,
			onToggleFavorite,
			isInShop,
			isOpenShop,
			onJoinShop,
			updateJoinShopStatus,
			onDownloadTourFile,
		};
	},
	data() {
		return {
			shareTooltipOptins: {
				content:
					"1.一键下载产品海报或复制产品链接，分享给客人无需<br/>下载任何软件，直接点看查看产品信息，方便又快捷。<br/><br/>2.产品对外分享仅展示零售价，并只展示您店铺的信息<br/>及联系方式，不会露出任何关于平台的元素。",
				trigger: "hover",
				classes: "shareHover",
				offset: "5px"
			}
		};
	},
	computed: {
		auth() {
			return this.$auth.$state;
		},
		isCustomer() {
			// 直客 未登录都看作是直客
			return (
				!this.auth.loggedIn ||
				(this.auth.loggedIn && this.auth.user && !this.auth.user.distributor)
			);
		},
		isDistributor() {
			if (!this.auth.loggedIn) return false;
			return !!this.auth.user.distributor;
		},
		productListLink() {
			return '/product/vacation/list'
			// return this.isDistributor
			// 	? "/resource/product/list/cruise"
			// 	: "/customer/list";
		}
	},
	methods: {
		//下载word行程
		async handleDownloadTravel() {
			this.$emit("update:loading", true);
			let tempName = this.data.title + ".doc";
			DownloadByStreamingFile(
				"/api//product/product/download-trip",
				{ product_no: this.data.product_no },
				tempName,
				"application/msword"
			);
			this.$emit("update:loading", false);
		},
		handleCopySuccess() {
			this.$message.success("复制成功");
		},
		handleCopyError() {
			this.$message.error("复制失败");
		},
		//分享店铺
		handleShareShopProduct() {
			this.updateJoinShopStatus(true);
			this.$refs.shareShopProduct.handleShareShopPrdouct(this.data);
		}
	}
});
</script>

<style lang="scss" scoped>

// @import "~@/assets/scss/base/public.scss";

.main-body {
	background-color: #fff;
	padding: 20px;
}

.download-btn,
.share-btn {
	padding: 7px 10px;
	width: 160px;

	::v-deep .icon {
		margin-right: 10px;
		width: 28px;
		height: 34px;
	}
}

.product-info {
	display: flex;
	align-items: flex-start;

	&-content {
		position: relative;
		flex: 1;

		.status-icon {
			position: absolute;
			width: 125px;
			height: 125px;
			right: 0;
			top: 104px;
		}
	}

	&-cover {
		width: 326px;
		height: 232px;
		margin-left: 24px;
		position: relative;
		border-radius: 6px;
		overflow: hidden;


		:deep(.el-carousel__indicators){
			display: flex;
			justify-content: center;
			min-width: 150px;

			.el-carousel__indicator{
				flex: 1;
				max-width: 30px;
			}
			.el-carousel__button{
				width: 100%;
			}
		}
	}
}

::v-deep .product {
	&-title {
		font-size: 20px;
		font-weight: 500;
		color: $important-text-color;
	}

	&-depart {
		color: $color-grey-3;
		margin: 7px 0;
	}

	&-tag-group {
		margin: 12px 0;

		.v-tag--primary {
			background-color: #fef1d7;
			color: #ff9500;
		}

		.v-tag--blue {
			background-color: #e2f4f3;
			color: #00b1a6;
		}

		.tag {
			& + & {
				margin-left: 4px;
			}
		}
	}

	&-base-info {
		.product-no {
			color: $color-grey-3;
		}

		.copy-no-btn {
			padding: 5px;
			display: inline-block;
			cursor: pointer;
			user-select: none;
		}
	}
}
.tour_btn{
	border: 1px solid #191919;
	color: $color-black-2;
	font-size:16px;
	font-weight: 400;
	border-radius: 4px;
	align-self: center;
	margin-left: auto;
	height: 40px;
	padding:0 12px 0 10px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	em{
		display: inline-block;
		vertical-align: middle;
		margin-top: -10px;
	}
}
.font_24{
	font-size: 24px;
}


</style>
<style>

.shareHover .tooltip-inner {
	background: rgba(0, 0, 0, 0.7) !important;
	padding: 20px;
	box-sizing: border-box;
}

.shareHover .tooltip-arrow {
	border-color: rgba(0, 0, 0, 0.7);
}
.popper-class-tooltip {
  border: 1px solid #D4D7DE !important;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1) !important;
  width: 248px !important;
  color: #1F2129;
  padding: 8px 10px 6px;
  margin-top: 2px !important;
  text-align: justify;
}

</style>
<style lang="scss" scoped>
.product__title--active {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.product__title__icon {
  margin-right: 5px;
}
.product__title__split {
  border-right: 1px solid #d8d8d8;
  margin: 0 10px;
  width: 1px;
  height: 1em;
  background-color: #d8d8d8;
}
.product__title__action {
  display: flex;
  align-items: center;
  height: 34px;
  padding: 0 14px;
  border-radius: 34px;
  border: 1px solid #D4D7DE;
  background: #fff;
}
.product__title__action span {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.productsale {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.productsale__wrapper {
  padding-top: 30px;
}
.productsale__item {
  border-width: 1px;
  flex-shrink: 0;
  width: 260px;
  height: 80px;
  margin-right: 14px;
  position: relative;
  border-image: linear-gradient(
  					322deg,
  					rgba(255, 245, 189, 1),
  					rgba(255, 190, 0, 1)
  				)
  				1 1;
  display: flex;
  align-items: center;
  padding: 0 20px 0 25px;
  border-radius: 4px;
  overflow: hidden;
}
.productsale__item::before {
  content: "";
  position: absolute;
  width: 52px;
  height: 47px;
  left: -1px;
  top: -1px;
  background: url("~assets/img/product/product_sale_icon.png") center
  					no-repeat;
  background-size: cover;
  z-index: 1;
}
.productsale__item::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(270deg, #fff5bd 0%, #ffbe00 100%);
  border-radius: 0 4px 4px 0px;
}
.productsale__item__icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  margin-right: 10px;
}
.productsale__item__name {
  color: #212529;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}
.productsale__item__company {
  color: #868e96;
  font-size: 13px;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.productsale__item__tag {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75px;
  right: 0;
  top: 14px;
  height: 26px;
  color: #212529;
  font-size: 13px;
  font-weight: 500;
  background: linear-gradient(122deg, #fff5bd 0%, #ffbe00 100%);
  border-radius: 14px 0px 0px 14px;
}
.productsale__item__tag .icon {
  margin-right: 6px;
}
.productsale ::v-deep .productsale__popover__wrapper {
  border: 1px solid #ffbe00;
}
.productsale ::v-deep .productsale__popover__wrapper .popper__arrow {
  border-bottom-color: #ffbe00;
}
.productsale__popover {
  color: #212529;
  font-size: 16px;
  width: 230px;
}
.productsale__popover__name {
  font-weight: 600;
}
.productsale__popover__phone {
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.productsale__popover__copy {
  color: #f03e3e;
  border-radius: 10px;
  border: 1px solid #f03e3e;
  text-align: center;
  line-height: 15px;
  padding: 0 5px;
  font-size: 12px;
  user-select: none;
  cursor: pointer;
}
.distributor__profit {
  margin-left: 10px;
}
.distributor__price {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.distributor__sale {
  display: flex;
  align-items: center;
  color: var(--text-color-price);
}
.distributor__sale__label {
  color: #49495b;
  font-size: 14px;
  font-weight: 500;
  margin-top: 6px;
}
.distributor__sale__rangin {
  font-weight: bold;
  font-size: 24px;
}
.distributor__sale .union {
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  margin-top: 3px;
}
.distributor__tip {
  display: flex;
  align-items: center;
  background-color: #fdf9e5;
  border-radius: 4px;
  color: #d78b1a;
  font-size: 14px;
  padding: 6px 14px;
  margin-top: 20px;
}
.distributor__tip .ficon {
  margin-right: 5px;
}
.distributor__tip pre {
  word-break: break-all;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.btn__shop {
  color: $highlight-color;
  border-color: #fbcec4;
  background-color: #feefeb;
}
.el-button--primary.is-plain {
  background: rgba(0,94,220,0.06) !important;
}
.product-name {
  display: flex;
  position: relative;
}
.info-name {
  text-indent: 28px;
  margin-left: -26px;
}
.label-icon {
  height: 28px;
  width: 28px;
  margin-left: -1px;
}
.title {
  font-weight: 500;
}
</style>
